export const FILTER_COLUMN_HEADER_HEIGHT = 64
export const FILTER_COLUMN_HEADER_GAP = 4

export const getFilterHeaderStyles = () => ({
  '& .MuiDataGrid-virtualScroller': {
    marginTop: `${FILTER_COLUMN_HEADER_HEIGHT + FILTER_COLUMN_HEADER_GAP}px`,
  },
  '& .MuiDataGrid-columnHeaders': {
    minHeight: `${FILTER_COLUMN_HEADER_HEIGHT}px`,
  },
})

export const filterHeaderTableProps = {
  isMinifiedColumnHeader: false,
  headerHeight: FILTER_COLUMN_HEADER_HEIGHT,
} as const
